import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ABAS_DO_CURSO } from '@/features/cursos/abas';
import { EditorDoCurso } from '@/features/cursos/componentes/EditorDoCurso';
import { LinkParaEnviar } from '@/features/pagamentos/componentes/NovoLink';
import { rotaDeTela } from '@/features/permissoes/guardas';

const busca = z.object({ aba: z.enum(ABAS_DO_CURSO).default('conteudo').catch('conteudo') });

/** Editor do curso (spec 019, CA-03 a CA-08; venda, spec 020), com a aba na URL. */
export const Route = createFileRoute('/_autenticado/cursos/$id')({
  ...rotaDeTela('cursos.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { id } = Route.useParams();
  const { aba } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <EditorDoCurso
      key={id}
      id={id}
      aba={aba}
      aoMudarAba={(nova) => {
        void navigate({ search: { aba: nova }, replace: true });
      }}
      linkGerado={(link) => <LinkParaEnviar link={link} />}
    />
  );
}
